<div class="dialog-container">
    <!-- Título do Diálogo -->
    <h2 mat-dialog-title>Filtrar Categoria</h2>
  
    <!-- Área de Conteúdo -->
    <div mat-dialog-content>
      <p>Insira os filtros desejados para refinar sua busca:</p>
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Categoria</mat-label>
        <input matInput placeholder="Digite a categoria">
      </mat-form-field>
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Descrição</mat-label>
        <textarea matInput placeholder="Digite a descrição"></textarea>
      </mat-form-field>
    </div>
  
    <!-- Botões na Parte Inferior -->
    <div mat-dialog-actions align="end" class="dialog-actions">
      <button mat-button mat-dialog-close>Cancelar</button>
      <button mat-raised-button color="primary" (click)="confirm()">Confirmar</button>
    </div>
  </div>
  